import { Component, HostListener, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { FacadeService } from './core/services/facade.service';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
	/**
	 * Taille de l'écran
	 */
	screenWidth: number;

	isHomeContent = true;
	isMobile = false;

	/* Contrôle de la sidebar */
	isSidebardHidden = true;

	constructor(private router: Router, private facade: FacadeService) {
		this.router.events.subscribe((event: any) => {
			if (event instanceof NavigationEnd) {
				let onLoginPage = event.url === '/login' || event.url === '/';
				let onRecoveryPage = event.url === '/recovery';
				let onConfirmAccountPage = event.url.includes('/confirmAccount');

				this.isHomeContent =
					onLoginPage || onRecoveryPage || onConfirmAccountPage;
			}
		});
	}

	ngOnInit(): void {
		this.screenWidth = window.innerWidth;
		this.isMobile =
			this.facade.mobileService.isMobile() || this.screenWidth < 1200;
	}

	toggleNavbar() {
		const isynav = document.getElementById('isynav');
		if (isynav.classList.contains('toggled')) {
			isynav.classList.remove('toggled');
		} else {
			isynav.classList.add('toggled');
		}
	}

	onActivate(event) {
		window.scroll(0, 0);
	}

	@HostListener('window:resize', ['$event'])
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < 1200) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	clearStorage() {
		this.facade.dataStorageService.clearStorage();
		this.facade.dataStorageService.clearSession();
		//this.facade.notificationService.ngOnDestroy();
		this.facade.messageService.ngOnDestroy();
	}

	getPagesClasses() {
		const classes = {
			'pages-width-when-navbar': !this.isSidebardHidden,
			'pages-width-without-navbar': this.isSidebardHidden && !this.isMobile,
			'pages-width-without-navbar-mobile': this.isMobile
		};
		return classes;
	}

	getClasses() {
		const classes = {
			'pinned-sidebar': this.isSidebardHidden,
			'login-background-img': this.isHomeContent && !this.isMobile,
			'login-background-img-mobile': this.isHomeContent && this.isMobile,
			'margin-navbar': !this.isHomeContent && !this.isMobile
		};
		return classes;
	}

	toggleSidebarPin() {
		this.isSidebardHidden = !this.isSidebardHidden;
	}
}
